/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'dossier': {
    width: 18,
    height: 18,
    viewBox: '0 0 18 18',
    data: '<g _fill="#FFF" fill-rule="evenodd"><path pid="0" d="M17.835 12.422a.375.375 0 00-.356-.26h-3.054l-.944-2.903c-.1-.31-.613-.31-.712 0l-.944 2.904H8.772a.375.375 0 00-.221.678l2.473 1.798-.882 2.876a.374.374 0 00.58.412l2.403-1.761 2.403 1.76a.371.371 0 00.439.005.376.376 0 00.141-.416l-.883-2.876 2.473-1.798a.374.374 0 00.137-.42"/><path pid="1" d="M4.125 4.5H1.28L4.5 1.28v2.845a.375.375 0 01-.375.375m9-4.5h-8.25c-.1 0-.195.04-.265.11l-4.5 4.5a.375.375 0 00-.11.265v11.25c0 .207.167.375.375.375h9.017c.165 0 .31-.107.358-.265l.322-1.048a.376.376 0 00-.138-.414L8.11 13.448a1.125 1.125 0 01.661-2.035h2.237a.376.376 0 00.356-.26l.691-2.126a1.122 1.122 0 011.07-.777.375.375 0 00.375-.375v-7.5A.375.375 0 0013.125 0"/></g>'
  }
})
